const ENABLE_LOG = import.meta.env.VITE_ENABLE_LOGS === 'true'

export default ENABLE_LOG && import.meta.env.MODE === 'development'
  ? console
  : { ...console, debug: () => {} }
